module.exports = "<symbol id=\"thebestco-uikit-svg-Neutral10\" viewBox=\"0 0 10 10\"><path d=\"M2 2H8V8H2z\"/></symbol>";